import {
  AfterContentInit,
  Component,
  inject,
  InjectionToken
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ParentItemProviderService } from '@app/shared';
import {
  normalizeLabel,
  normalizeOptionLabel
} from '@app/shared/util/common-utils';
import { DynamicFormService, FORM_SERVICE_PROVIDER_TOKEN } from '@ntap/common';
import {
  AttributeStateService,
  ItemInfo,
  ItemView,
  ItemViewProviderDirective,
  NtapCommonComponent
} from '@ntap/core';
import { delay, of, startWith, switchMap, tap } from 'rxjs';

export const FIZICKI_OBJEKT_PARENT_ITEM = new InjectionToken<
  ItemViewProviderDirective<ItemView>
>('POJAVNI_OBLIK_ITEM');
export const FIZICKI_OBJEKT_PARENT_FORM =
  new InjectionToken<DynamicFormService>('POJAVNI_OBLIK_FORM');

@Component({
  selector: 'app-pojavni-oblik',
  templateUrl: './pojavni-oblik.component.html',
  styleUrls: ['./pojavni-oblik.component.scss'],
  providers: [
    ParentItemProviderService,
    {
      provide: FORM_SERVICE_PROVIDER_TOKEN,
      useClass: DynamicFormService
    },
    {
      provide: DynamicFormService,
      useExisting: FORM_SERVICE_PROVIDER_TOKEN
    },
    {
      // re-provide context to child components
      provide: FIZICKI_OBJEKT_PARENT_ITEM,
      useExisting: ItemViewProviderDirective
    },
    {
      provide: FIZICKI_OBJEKT_PARENT_FORM,
      useExisting: FORM_SERVICE_PROVIDER_TOKEN
    }
  ]
})
export class PojavniOblikComponent
  extends NtapCommonComponent
  implements AfterContentInit
{
  private formService = inject(DynamicFormService);
  private attributeStateService = inject(AttributeStateService);
  private itemViewProvider = inject(ItemViewProviderDirective);

  obrazacClass: string;

  ngAfterContentInit(): void {
    this.addSubscription(
      this.itemViewProvider.item$
        .pipe(
          delay(0),
          switchMap((item: any) => {
            return this.formService.formGroup$.pipe(
              switchMap((fg) => {
                const vrstaControl =
                  fg.get('en~pojavni_oblik~vrsta_pojavnog_oblika') ||
                  ({ valueChanges: of(null) } as AbstractControl);

                return vrstaControl.valueChanges.pipe(
                  startWith(
                    this.formService.getFormValue(
                      'en~pojavni_oblik~vrsta_pojavnog_oblika'
                    )
                  ),
                  switchMap((value) => {
                    return this.fetchOptions(item).pipe(
                      tap((options) => {
                        const option = options.filter(
                          (o) => o.value === value
                        )[0] || { label: '' };
                        const normalizedLabel = normalizeOptionLabel(option);
                        const normalizedTypeLabel = normalizeLabel(
                          this.formService.getFormValue(
                            'en~pojavni_oblik~tip_pojavnog_oblika'
                          )
                        );
                        this.obrazacClass = `vrsta-${normalizedLabel} tip-${normalizedTypeLabel}`;
                      })
                    );
                  })
                );
              })
            );
          })
        )
        .subscribe()
    );
  }

  private fetchOptions(item: any) {
    return this.attributeStateService.getAllowedValues(
      {
        $fqan: 'en~pojavni_oblik~vrsta_pojavnog_oblika',
        name: 'en~pojavni_oblik~vrsta_pojavnog_oblika'
      },
      {
        ['en~pojavni_oblik~id']: new ItemInfo(item).id,
        ['en~pojavni_oblik~tip_pojavnog_oblika']: this.formService.getFormValue(
          'en~pojavni_oblik~tip_pojavnog_oblika'
        )
      },
      'pojavni_oblici_item'
    );
  }
}
